import { render, staticRenderFns } from "./AutosizeTextarea.vue?vue&type=template&id=1dc96ac9&"
import script from "./AutosizeTextarea.vue?vue&type=script&lang=js&"
export * from "./AutosizeTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports